import styled from "styled-components";
import {
  Cog6ToothIcon,
  MagnifyingGlassIcon,
} from "@heroicons/react/24/outline";
import { External } from "@sablier/v2-components/atoms";
import { Button } from "@sablier/v2-components/molecules";
import { DEFAULT_TOKEN_LIST } from "@sablier/v2-constants";
import { useT } from "@sablier/v2-locales";
import { _ } from "@sablier/v2-mixins";

const WrapperPartial = styled.div`
  ${(props) => props.theme.styles.row}
  & {
    width: 100%;
    padding: calc(${(props) => props.theme.sizes.edge} * 1)
      ${(props) => props.theme.sizes.modalEdge};
    border-top: 2px solid ${(props) => props.theme.colors.border};
  }
`;

const Version = styled(External)`
  margin-right: auto;
  & > p {
    ${(props) => props.theme.styles.textParagraphMini}
    & {
      color: ${(props) => props.theme.colors.gray400};
      &:hover,
      &:active {
        text-decoration: underline;
      }
    }
  }
`;

const Actions = styled.div`
  ${(props) => props.theme.styles.row}
  & {
    gap: ${(props) => props.theme.sizes.edge};
    min-height: ${(props) => props.theme.sizes.buttonMini};
  }
`;

const Wrapper = styled(WrapperPartial)`
  ${(props) => props.theme.medias.maxMD} {
    padding: calc(${(props) => props.theme.sizes.edge} * 3 / 2);
  }
  ${(props) => props.theme.medias.maxSM} {
    padding: calc(${(props) => props.theme.sizes.edge} * 1 / 2);
    ${Actions} {
      gap: calc(${(props) => props.theme.sizes.edge} * 1 / 2);
    }
  }
  ${(props) => props.theme.medias.maxXXS} {
    ${Version} {
      display: none;
    }
    ${Actions} {
      width: 100%;
      & > * {
        flex: 1;
      }
    }
  }
`;

interface Props {
  isManageShown?: boolean;
  isRegistryShown?: boolean;
  onManage: () => void;
  onRegistry: () => void;
}

export default function Footer({
  isManageShown = true,
  isRegistryShown = true,
  onManage,
  onRegistry,
}: Props) {
  const { t } = useT();
  return (
    <Wrapper>
      <Version to={DEFAULT_TOKEN_LIST.homepage}>
        <p>v1.0.0</p>
      </Version>
      <Actions>
        {isRegistryShown && (
          <Button
            accent={"iconic400"}
            appearance={"outline"}
            isMini
            onClick={onRegistry}
            right={MagnifyingGlassIcon}
            title={t("structs.searchOnChainList")}
            titleShort={t("words.custom")}
          />
        )}
        {isManageShown && (
          <Button
            accent={"iconic400"}
            appearance={"outline"}
            isMini
            onClick={onManage}
            right={Cog6ToothIcon}
            title={t("words.manage")}
          />
        )}
      </Actions>
    </Wrapper>
  );
}
